import React from 'react'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { Button } from '../../../../interaxDesignSystemComponents'
import { TESTIDS } from '../../../../config/testids'
import { useUser } from '../../../../hooks/useUser'
import { isPlatformTourAvailable } from '../platformTourStops'
import { usePlatformTourControls } from '../hooks/usePlatformTourControls'

/** Starts the tour again from its first stop, whatever they did with it before. */
export const ReplayPlatformTourButton: React.FC = () => {
  const { t } = useTranslation()
  const { data: user } = useUser()
  const { showStop } = usePlatformTourControls()

  if (!isPlatformTourAvailable(user)) return null

  return (
    <Button
      variant="secondary"
      size="small"
      onClick={() => showStop(0)}
      data-testid={TESTIDS.PLATFORM_TOUR_SETTINGS_REPLAY_BTN}
    >
      {t('gamer.platformTour.replayPlatformTour')}
    </Button>
  )
}
